module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.37823/js/img/creditsCallout/generic.svg"